import $ from 'jquery';
const cp = {
    init(config){
      this.config = config;
      let staticServer = (window.medscape.config.env=='localhost') ? '//img.proddev.medscapestatic.com' : window.medscape.config.staticServer.host;
      let url = `${staticServer}/medscape-core/shared-all/js/cp/cp.js`;
      $.getScript( url , ( data, textStatus, jqxhr ) => {
        $(document).ready(()=>{
          this.particip(config);
          this.requestCSD(config);
        })
        window.addEventListener('load', () => {
          this.load(config);
        });
        let unloadEvent = document.pagehide ? 'pagehide' : 'beforeunload';
        $(window).on(unloadEvent, () => {
            this.dropOff(config);
        });

      });
    },
    load(config) {
      let cpData = $.extend({},config);
      window.postCp(cpData);
    },
    particip(config) { 
        let cpData = $.extend({},config,{
          activityName: "participation"
        });
        window.postCp(cpData);
    },
    dropOff(config) {
        let cpData = $.extend({},config,{
          activityName: "drop-off"
        });
        window.postCp(cpData);
    },
    requestCSD(config) {
        let cpData = $.extend({},config,{
          activityName: "requestCSD"
        });
        window.postCp(cpData);
    },
    content(activityName=this.config.activityName){

      const event = {
            tacticId: this.config.tacticId,
          activityId: this.config.activityId,
             appname: this.config.appname,
        activityName: activityName
      };
      if(typeof window.postCp !== 'undefined') {
        window.postCp(event);
      }

    }
}
export default cp;


// WEBPACK FOOTER //
// ./medscape_modules/tracking/cp.js